import { View } from "react-native";
import { styledRN } from "./styled";
export const InputContainer = styledRN(View, ({ $theme }) => ({
    backgroundColor: $theme.midground,
    borderRadius: 10,
    paddingLeft: 10,
    paddingRight: 10,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
}));
